<script>
import { mixins, Doughnut } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  name: "donut-chart",
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ["options", "chartData"],
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
</script>
